export default __webpack_public_path__ + "static/leverOff-23a50308d33e5d7f65bcc9169350cff8.png";